export default "__VITE_ASSET__BX3_V8Ve__"